import { gql } from '@apollo/client';

export default gql`
  query GetActiveInvitationsAtProject($id: ID!) {
    viewer {
      id
      project(id: $id) {
        id
        invitations(status: "active") {
          nodes {
            id
          }
        }
      }
    }
  }
`;
